import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { StaticQuery, graphql, Link } from "gatsby"
import "./index.css";
import { navigate } from '@reach/router';
import Tags from "../components/tags";
import Social from '../components/social';
import DateFormatter from "../components/date-formatter"


const IndexPage = () => (
  <>
        <br/>
        <h4 className='title'>
          ULTIMI ARTICOLI
        </h4>
        <StaticQuery
        query={graphql`
          query {
            allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC},
              filter: {fileAbsolutePath: {regex: "\/posts\/"}}, limit: 6) {
              totalCount
              edges {
                  node {
                    frontmatter {
                      title
                      date
                      author
                      slug
                      thumbnail
                    }
                    html
                    internal {
                      type
                      mediaType
                      description
                    }
                    excerpt
                    
                  }
            
              }
            }
          }
        `}
        render={data => {
          return data.allMarkdownRemark.edges.map((elem, id) => {
            return <Link className="articlePrev" to={'/post/'+elem.node.frontmatter.slug} style={{textDecoration: 'none', color: 'hsla(0, 0%, 0%, 0.8)'}}>
            <div className="articleImage"
              style={{
                display: "flex",
                alignItems: "center"
              }}
            >
              <div
                className="image"
                style={{
                  backgroundImage: `url(${elem.node.frontmatter.thumbnail})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: 'center',
                  width: '100%',
                  backgroundSize: 'cover'
                }}
              >
              </div>
            </div>
            <div className="articleContent">
              <div class="articlePrevAuthor">
               <DateFormatter date={elem.node.frontmatter.date} /> - {elem.node.frontmatter.author}
              </div>
              <h3 className="articlePrevTitle">
                {elem.node.frontmatter.title}
              </h3>
              <div className="articlePrevText"
              
              >
                <div className="textContainer"
                style={{
                  /*
                  display: '-webkit-box',
                  '-webkit-line-clamp': 3,*/
                  '-webkit-box-orient': 'vertical'
                }}>
                  {elem.node.html.substring(0,400).replace(/<(?:.|\n)*?>/gm, '')}...
                </div> 
              </div>
              
            </div>
           
            </Link>;
          });
        }
      }
      />
      <div className='otherArticles'>
        <span
          style={{
            cursor: 'pointer'
          }}
          onClick={()=> {
            navigate('/archivio');
          }}>
        ALTRI ARTICOLI</span>
      </div>
      </>
)

export default IndexPage
